import React from 'react';
import Chart from 'react-apexcharts';

export default function TotalPlayers({ totalUsers, chartSeries, loading, error }) {
  const chartOptions = {
    chart: {
      type: 'radialBar',
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: '60%',
        },
        dataLabels: {
          name: {
            show: true,
            fontSize: '12px',
            color: '#ffffff'
          },
          value: {
            fontSize: '18px',
            show: true,
            color: '#ffffff',
            formatter: function () {
              return totalUsers.toString();
            }
          }
        }
      }
    },
    labels: ['Players'],
    colors: ['#5C1FE2']
  };

  return (
    <div className="lg:w-[100%] flex justify-center items-center px-5">
      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p>{error}</p>
      ) : (
        <Chart
          options={chartOptions}
          series={chartSeries || [0]} // Fallback to [0] if chartSeries is undefined
          type="radialBar"
          className="scale-125"
          height={180}
          width={130}
        />
      )}
    </div>
  );
}